// extracted by mini-css-extract-plugin
export default {"back-button":"notifications-drawer_back-button__1VrwH","close-button":"notifications-drawer_close-button__ERXK4"};